import { readCookieCategories } from '@zapier/cookies';

// Read analytics (OneTrust C0002) consent synchronously so already-consented visitors
// are tracked from page load rather than waiting for the consent event to re-render.
export function analyticsConsentGranted(): boolean {
  try {
    return Boolean(readCookieCategories().byName.analytics);
  } catch {
    return false;
  }
}
